import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {};

const path = "admin/dashboard"


export const Counts = async () => {
    return await axiosInstance(options).post(`${path}/counts`);
}

export const DateWiseEarnings = async (range) => {
    return await axiosInstance(options).get(`${path}/date-wise-earnings?range=${range}`);
}

export const DateWiseActiveUsers = async (range) => {
    return await axiosInstance(options).get(`${path}/date-wise-active-users?range=${range}`);
}



